import React, { useState, useEffect } from "react"

// Components
import PrimeField from "components/PrimeField/PrimeField"
import { useGetCountries } from "api/hooks/enum"

const SiteCountryDropdown = (props) => {
  const { data: countries } = useGetCountries()

  const [isDisabled, setDisabled] = useState(false)
  const [selectedItem, setSelectedItem] = useState(null)
  const [invalid, setInvalid] = useState(false)
  const [invalidText, setInvalidText] = useState("")
  const options = props.uiSchema["ui:options"]
  const placeholder = options.placeholder

  useEffect(() => {
    let { value, schema, uiSchema } = props
    if (value) setSelectedItem(value)
    if (uiSchema) {
      if (uiSchema["ui:readonly"] || uiSchema["ui:disabled"]) {
        setDisabled(true)
      }
    }
  }, [props.value])

  useEffect(() => {
    if (options.required) {
      if (selectedItem) {
        setInvalid(false)
        setInvalidText("")
      } else {
        setInvalid(true)
        if (options.invalidText) {
          setInvalidText(options.invalidText)
        } else {
          setInvalidText("This is a required field.")
        }
      }
    }
  }, [selectedItem])

  const items = React.useMemo(() => {
    if (countries) {
      return Object.keys(countries)
        .map((key) => ({ label: countries[key].label, value: countries[key].label }))
        .sort((a, b) => a?.label?.localeCompare(b?.label))
    }
  }, [countries])

  return (
    <div>
      <PrimeField
        schema={{
          id: props.id,
          type: "dropdown",
          placeholder,
          items,
        }}
        status={invalid && "error"}
        disabled={isDisabled}
        errorMessage={invalidText}
        showError={invalid}
        value={props.value}
        onChange={props.onChange}
      />
    </div>
  )
}

export default SiteCountryDropdown
